/**
 * author: Ananthapadmanabhan V K
 */
import { Button, Modal } from "react-bootstrap";

const ConfirmDialog = (props) => {
    const { title, children, open, setOpen, onConfirm } = props;
    return (
        <Modal show={open}
            onHide={() => setOpen(false)}
            size="sm"
            aria-labelledby="contained-modal-title-vcenter"
            centered>
            {title &&
                <Modal.Header closeButton>
                    <Modal.Title>
                        {title}
                    </Modal.Title>
                </Modal.Header>
                }

            <Modal.Body>
                <div className="d-flex align-items-center justify-content-center shortDataHeight">
                    {children}
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" className="px-3" onClick={() => setOpen(false)}>
                    Cancel
                </Button>
                <Button variant="primary" className="px-4 sbmBtn"
                    onClick={() => {
                        setOpen(false);
                        onConfirm();
                    }} >
                    Ok
                </Button>

            </Modal.Footer>
        </Modal>
    );
};
export default (ConfirmDialog);